import React from 'react';
import styles from './CardOptionButton.module.scss';
import { SFIcon } from 'sfui';
import { InteractiveBox } from 'ui-smartforce-settings';

export interface CardOptionButtonProps {
  icon: string;
  label: string;
  onClick: () => void;
}

export const CardOptionButton = (
  props: CardOptionButtonProps
): React.ReactElement<CardOptionButtonProps> => {
  return (
    <InteractiveBox className={styles.cardOptionButton} onClick={props.onClick}>
      <div className={styles.icon}>
        <SFIcon size="42px" icon={props.icon} />
      </div>
      <h3>{props.label}</h3>
    </InteractiveBox>
  );
};
